var APP_CONFIG = {
  CHECKOUT_FIELDS: {
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
    ADDRESS_LINE1: "addressLine1",
    ADDRESS_LINE2: "addressLine2",
    CITY: "city",
    STATE: "stateOrProvince",
    POSTAL_CODE: "postalCode",
    PHONE_NUMBER: "phoneNumber"
  }
};
export default APP_CONFIG;